<svg class="w-4 h-4" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M14.804 7.043c0-3.89-3.134-7.043-7-7.043s-7 3.153-7 7.043c0 3.515 2.56 6.429 5.906 6.957V9.079H4.933V7.043H6.71V5.49c0-1.765 1.046-2.74 2.644-2.74.766 0 1.567.138 1.567.138v1.733h-.882c-.87 0-1.141.543-1.141 1.1v1.32h1.941l-.31 2.037H8.898V14c3.346-.528 5.906-3.442 5.906-6.957Z"
    fill="currentColor" />
</svg>